import React, { memo, useEffect, useMemo, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { deleteOrderApi } from '../../../api/trade';
import { actionsTypes, getAccountTradeId } from '../../../config';
import { Notification } from '../../../utilities/alert';
import moment from 'moment';
import { setEditDialog } from '../../../redux/reducer/edit-dialog';
import { makeOrderSelector } from '../../../redux/selector';
import { useAppSelector } from '../../../redux/app';
import { setPayload } from '../../../redux/reducer/payload';
import PriceCurrent from '../components/CurrentPrice';
import { Typography } from '@vt/vt-ui';

const List = memo(({ item, index }) => {
  const dispatch = useDispatch();
  const payload = useAppSelector((state) => state.payload?.payload);
  const { type } = useSelector(({ tradeDialog }) => tradeDialog);
  const [loading, setLoading] = useState(null);
  const [explan, setExplan] = useState(null);
  const [loadingTransition, setLoadingTransition] = useState(null);

  useEffect(() => {
    if (explan !== null) {
      setTimeout(() => {
        setLoadingTransition(explan);
      }, 200);
    } else {
      setLoadingTransition(null);
    }
  }, [explan]);

  const deleteOrder = async (item, index) => {
    try {
      setLoading(index);
      const { data } = await deleteOrderApi({
        account_trade_id: getAccountTradeId(),
        ticket: item.positionId
      });
      Notification({
        title: 'Delete order',
        message: data.data.message,
        type: 'success'
      });
      setLoading(null);
    } catch ({ response }) {
      Notification({
        message: response.data.error.message,
        type: 'danger'
      });
      setLoading(null);
    }
  };
  return (
    <div>
      <div className={`table-body ${explan === index ? 'table-order-open' : ''}`}>
        <div
          style={{
            padding: '12px 8px',
            transformOrigin: 'top',
            transform: type === 'port' ? 'translateX(0)' : 'translateX(-100%)',
            transition:
              type === 'port'
                ? `transform ${index < 15 ? 0 : 60 * index}ms ease-in`
                : 'all 0.3ms ease-in'
          }}>
          <div className="h-full">
            <div className="flex gap-2 items-center">
              <div className="w-[32px]">
                <img
                  src={`https://storage.googleapis.com/iux-storage/symbol/${item?.symbol}.png`}
                  alt="..."
                  onError={({ currentTarget }) => {
                    currentTarget.src = 'globe.svg';
                  }}
                  className="w-full rounded-[50%]"
                />
              </div>
              <div
                className="pointer center-position-ele flex-1"
                onClick={() => {
                  if (explan === index) {
                    setExplan(null);
                  } else {
                    setExplan(index);
                  }
                }}>
                <div className="flex items-center gap-2">
                  <div className="text-[14px] text-[#e5e5e5] font-bold">{item?.symbol}</div>
                  <div className="flex items-center gap-2" style={{
                    color: actionsTypes[item?.type]?.color
                  }}>
                    <div
                      className="text-sm font-bold"
                    >
                      {actionsTypes[item?.type]?.name}
                    </div>
                    <div className="text-sm font-bold">
                      {((item?.volumeCurrent / 100)) / 100}
                    </div>
                  </div>
                </div>
                <div>
                  <div className="flex w-100 gap-1 mt-1">
                    <PriceCurrent digits={item?.digits} type={item?.type} symbol={item?.symbol} />
                    {/*<div className="text-xs text-[#e5e5e5]">{item.priceCurrent?.toFixed(item.digits)}</div>*/}
                    <div className="flex items-center justify-center">
                      <svg
                        width="14"
                        height="14"
                        viewBox="0 0 16 16"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg">
                        <g clipPath="url(#clip0_2255_631)">
                          <path
                            d="M15.8167 7.55759C15.8165 7.5574 15.8163 7.55719 15.8161 7.557L12.5504 4.307C12.3057 4.06353 11.91 4.06444 11.6665 4.30912C11.423 4.55378 11.4239 4.9495 11.6686 5.193L13.8612 7.375H0.625C0.279813 7.375 0 7.65481 0 8C0 8.34519 0.279813 8.625 0.625 8.625H13.8612L11.6686 10.807C11.4239 11.0505 11.423 11.4462 11.6665 11.6909C11.91 11.9356 12.3058 11.9364 12.5504 11.693L15.8162 8.443C15.8163 8.44281 15.8165 8.44259 15.8167 8.4424C16.0615 8.19809 16.0607 7.80109 15.8167 7.55759Z"
                            fill="#9F9F9F"
                          />
                        </g>
                        <defs>
                          <clipPath id="clip0_2255_631">
                            <rect width="16" height="16" fill="white" />
                          </clipPath>
                        </defs>
                      </svg>
                    </div>
                    <div className="text-xs text-[#9f9f9f]">{parseFloat(item?.priceOrder).toFixed(item?.digits)}</div>
                  </div>
                </div>
              </div>
              <div className="right-position-ele">
                <div className="text-right text-[#28AFFF] text-sm font-bold">Placed</div>
                <div className="action-order flex items-center gap-2 justify-end mt-1">
                  <button
                    className="outline-custom"
                    onClick={() => {
                      if (explan === index) {
                        setExplan(null);
                      } else {
                        setExplan(index);
                      }
                    }}>
                    <svg
                      className={`m-auto ${explan === index ? 'relate-180' : 'rotate-0'}`}
                      width="16"
                      height="16"
                      viewBox="0 0 16 16"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg">
                      <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M8.00016 10.6666C8.17697 10.6666 8.34654 10.5964 8.47157 10.4714L12.4716 6.47136C12.7319 6.21101 12.7319 5.7889 12.4716 5.52855C12.2112 5.2682 11.7891 5.2682 11.5288 5.52855L8.00016 9.05715L4.47157 5.52855C4.21122 5.2682 3.78911 5.2682 3.52876 5.52855C3.26841 5.7889 3.26841 6.21101 3.52876 6.47136L7.52876 10.4714C7.65378 10.5964 7.82335 10.6666 8.00016 10.6666Z"
                        fill="#9f9f9f"
                      />
                    </svg>
                  </button>
                  <button
                    className="outline-custom"
                    onClick={() => {
                      let typeExec = {
                        2: 'editBuyLimit',
                        3: 'editSellLimit',
                        4: 'editBuyStop',
                        5: 'editSellStop',
                        6: 'editBuyStopLimit',
                        7: 'editSellStopLimit'
                      };
                      dispatch(
                        setPayload({
                          ...payload,
                          price_order: item.priceOrder,
                          price_trigger: item.priceTrigger,
                          volume: item.volumeCurrent,
                          position: item.positionId,
                          time_expiration: item.time_expiration,
                          type_time: item.type_time
                        })
                      );
                      dispatch(
                        setEditDialog({
                          isOpen: true,
                          type: typeExec[item.type],
                          data: {
                            ...item,
                            position: item.positionId,
                            volume: item.volumeCurrent,
                            priceOrder: item.priceOrder,
                            priceTrigger: item.priceTrigger,
                            time_expiration: item.time_expiration,
                            type_time: item.type_time
                          }
                        })
                      );
                    }}>
                    <svg
                      className="m-auto"
                      width="16"
                      height="16"
                      viewBox="0 0 16 16"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg">
                      <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M11.1359 1.92124C11.917 1.14019 13.1833 1.14019 13.9643 1.92124C14.7454 2.70228 14.7454 3.96861 13.9643 4.74966L9.3897 9.32431C9.37484 9.33917 9.36015 9.35386 9.34563 9.36839C8.87989 9.83422 8.58704 10.1271 8.24911 10.3631C7.94965 10.5722 7.62668 10.7454 7.28683 10.8791C6.90333 11.0301 6.4973 11.112 5.85159 11.2422C5.83146 11.2462 5.81109 11.2503 5.79048 11.2545L5.46519 11.3201C5.25291 11.363 5.03305 11.3 4.8756 11.1513C4.71816 11.0026 4.64274 10.7867 4.67337 10.5723L4.705 10.3509C4.70829 10.3279 4.71153 10.3052 4.71474 10.2827C4.81731 9.56412 4.8818 9.11233 5.03058 8.68489C5.16238 8.30622 5.34243 7.94611 5.56629 7.61346C5.81897 7.23798 6.14172 6.91531 6.65503 6.40211C6.67109 6.38606 6.68733 6.36983 6.70376 6.3534L11.1359 1.92124ZM10.3333 4.60944L7.64657 7.2962C7.06895 7.87382 6.84435 8.10246 6.67246 8.35788C6.51257 8.59548 6.38396 8.8527 6.28981 9.12318C6.22588 9.30687 6.18312 9.50098 6.13116 9.82293C6.44394 9.75528 6.62634 9.70619 6.79848 9.63844C7.04123 9.54289 7.27192 9.41917 7.48583 9.26983C7.71573 9.10932 7.92295 8.90544 8.44689 8.3815L11.2761 5.55225L10.3333 4.60944ZM12.219 4.60944L11.2761 3.66663L12.0787 2.86405C12.3391 2.6037 12.7612 2.6037 13.0215 2.86404C13.2819 3.12439 13.2819 3.5465 13.0215 3.80685L12.219 4.60944ZM4.77431 1.99996L7.33333 1.99996C7.70152 1.99996 8 2.29844 8 2.66663C8 3.03482 7.70152 3.33329 7.33333 3.33329H4.8C4.41563 3.33329 4.16745 3.33381 3.97856 3.34925C3.79745 3.36404 3.7303 3.38916 3.69734 3.40596C3.5719 3.46987 3.46991 3.57186 3.406 3.6973C3.3892 3.73026 3.36408 3.79741 3.34929 3.97852C3.33385 4.16741 3.33333 4.41559 3.33333 4.79996V11.2C3.33333 11.5843 3.33385 11.8325 3.34929 12.0214C3.36408 12.2025 3.3892 12.2697 3.406 12.3026C3.46991 12.4281 3.5719 12.53 3.69734 12.594C3.7303 12.6108 3.79745 12.6359 3.97856 12.6507C4.16745 12.6661 4.41563 12.6666 4.8 12.6666H11.2C11.5844 12.6666 11.8326 12.6661 12.0214 12.6507C12.2026 12.6359 12.2697 12.6108 12.3027 12.594C12.4281 12.53 12.5301 12.4281 12.594 12.3026C12.6108 12.2697 12.6359 12.2025 12.6507 12.0214C12.6661 11.8325 12.6667 11.5843 12.6667 11.2V8.33329C12.6667 7.9651 12.9651 7.66663 13.3333 7.66663C13.7015 7.66663 14 7.9651 14 8.33329V11.2257C14 11.5771 14 11.8803 13.9796 12.13C13.9581 12.3935 13.9105 12.6557 13.782 12.9079C13.5903 13.2843 13.2843 13.5902 12.908 13.782C12.6557 13.9105 12.3936 13.958 12.13 13.9796C11.8803 14 11.5771 14 11.2257 14H4.77429C4.42286 14 4.11969 14 3.86998 13.9796C3.60642 13.958 3.34427 13.9105 3.09202 13.782C2.7157 13.5902 2.40974 13.2843 2.21799 12.9079C2.08946 12.6557 2.04191 12.3935 2.02038 12.13C1.99998 11.8803 1.99999 11.5771 2 11.2257V4.77426C1.99999 4.42283 1.99998 4.11966 2.02038 3.86994C2.04191 3.60638 2.08946 3.34423 2.21799 3.09198C2.40973 2.71566 2.7157 2.40969 3.09202 2.21795C3.34427 2.08942 3.60642 2.04187 3.86998 2.02034C4.1197 1.99994 4.42287 1.99995 4.77431 1.99996Z"
                        fill="#9f9f9f"
                      />
                    </svg>
                  </button>
                  <button className="outline-custom" onClick={() => deleteOrder(item, index)}>
                    {loading === index ? (
                      <div className="loader-css"></div>
                    ) : (
                      <svg
                        width="16"
                        height="16"
                        viewBox="0 0 16 16"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg">
                        <path
                          fillRule="evenodd"
                          clipRule="evenodd"
                          d="M3.52876 3.52864C3.78911 3.26829 4.21122 3.26829 4.47157 3.52864L8.00016 7.05723L11.5288 3.52864C11.7891 3.26829 12.2112 3.26829 12.4716 3.52864C12.7319 3.78899 12.7319 4.2111 12.4716 4.47145L8.94297 8.00004L12.4716 11.5286C12.7319 11.789 12.7319 12.2111 12.4716 12.4714C12.2112 12.7318 11.7891 12.7318 11.5288 12.4714L8.00016 8.94285L4.47157 12.4714C4.21122 12.7318 3.78911 12.7318 3.52876 12.4714C3.26841 12.2111 3.26841 11.789 3.52876 11.5286L7.05735 8.00004L3.52876 4.47145C3.26841 4.2111 3.26841 3.78899 3.52876 3.52864Z"
                          fill="#9f9f9f"
                        />
                      </svg>
                    )}
                  </button>
                </div>
              </div>
            </div>
            {explan === index && (
              <>
                <div className="h-[16px]"></div>
                <div
                  className={`explan-setting ${explan === loadingTransition ? 'open' : 'close'}`}>
                  <div className="flex text-[#e5e5e5] setting">
                    <div className="tp">
                      <div className='text-[#9f9f9f]'>TP</div>
                      <div className='text-[#9f9f9f]'>{item.priceTP !== 0 ? item.priceTP : 'No TP'}</div>
                    </div>
                    <div className="progress">
                      <div className="progress-sl-tp text-[#e5e5e5]"></div>
                      <div className="bg-progress-sltp text-[#e5e5e5]"></div>
                    </div>
                    <div className="sl">
                      <div className='text-[#9f9f9f]'>SL</div>
                      <div className='text-[#9f9f9f]'>{item.priceSL !== 0 ? item.priceSL : 'No SL'}</div>
                    </div>
                  </div>
                  <div className="flex justify-between position-detail-setting text-[#9f9f9f]">
                    <div className="open-time text-[#9f9f9f]">Open Time</div>
                    <Typography variant='h5' className="time-value text-[#9f9f9f]">
                      {moment.unix(item.timeCreate).utc().format('YYYY.MM.DD HH:mm:ss')}
                    </Typography>
                  </div>
                </div>
              </>
            )}
          </div>
        </div>
      </div>
    </div>
  );
});

List.displayName = 'List';

const OrderTable = () => {
  const getOrders = useMemo(makeOrderSelector, []);
  const orders = useAppSelector((state) => getOrders(state));
  const { type } = useSelector(({ tradeDialog }) => tradeDialog);
  return (
    <div className={`position-dialog border-r border-[#232323]`}>
      <div className="header">
        <div className="grid grid-cols-[20%_55%_25%] flex-header">
          <p className='text-[#e5e5e5]'>Order</p>
          <div className="flex items-center gap-2">
            <p className="mr-9 text-[#e5e5e5]">Symbol</p>
            <p className="mr-[30px] text-[#e5e5e5]">Type</p>
            <p className='text-[#e5e5e5]'>Volume</p>
          </div>
          <p className="text-end text-[#e5e5e5]">Status</p>
        </div>
      </div>
      <div id="custom-order-scroll" className={type === 'port' ? 'table-order-scroll' : ''}>
        {orders?.map((ele, i) => (
          <List item={ele} index={i} key={i} />
        ))}
      </div>
    </div>
  );
};

export default OrderTable;
